export const TeamRegistrationApiEndpoints = {
  FETCH_ORGANIZATION_TEAMS: "/team/organization",
  CALCULATE_ADD_TEAM_PRICES:
    "/registration-setting-calculation/registration-option-prices",
  SETUP_REGISTRATION: "/registration-setting-setup",
  AUTO_SAVE_SETUP_REGISTRATION: "/registration-setting-setup",
  FETCH_SETUP_FORM_STEP_DETAILS: "/registration-setting-setup",
  CREATE_TAG: "/registration-setting-tag",
  SEARCH_TAGS: "/registration-setting-tag",
  DELETE_TAG: "/registration-setting-tag",
  FETCH_TAGS_BY_REGISTRATION_SETTING_ID:
    "/registration-setting-tag/registration-setting",
  BIND_TAG: "/registration-setting-setup",
  CALCULATE_INSTALLMENTS: "/registration-setting-calculation/installments",
  FETCH_PROMO_CODES: "/registration-setting-promo-codes/registration-setting",
  ADD_NEW_PROMO_CODE: "/registration-setting-promo-codes/registration-setting",
  UPDATE_PROMO_CODE: "/registration-setting-promo-codes",
  DELETE_PROMO_CODE: "/registration-setting-promo-codes",
  FETCH_INSTALLMENTS:
    "/registration-setting-payment-installment/registration-setting",
  SAVE_INSTALLMENTS:
    "/registration-setting-payment-installment/registration-setting",
  FETCH_ADD_ONS: "/registration-add-on/registration-setting",
  CREATE_ADD_ON: "/registration-add-on/registration-setting",
  UPDATE_ADD_ON: "/registration-add-on/add-on-item",
  DELETE_ADD_ON: "/registration-add-on/add-on-item",
  FETCH_INVITATIONS_SUMMARY:
    "/registration-setting-invitation/registration-setting",
  SAVE_INVITATIONS: "/registration-setting-invitation/registration-setting",
  SAVE_LAUNCH_REGISTRATION_DRAFT:
    "/registration-setting-launch/registration-setting",
  LAUNCH_REGISTRATION: "/registration-setting-launch/registration-setting",
  FETCH_LAUNCH_SUMMARY: "/registration-setting-launch/registration-setting",
  FETCH_INVITED_EMAILS: "/registration-setting-invitation/registration-setting",
  FETCH_INVITATION_PLAYERS_AND_ORG_UNITS_CANDIDATES:
    "/registration-setting-invitation/registration-setting",
  FETCH_INVITED_PLAYERS_AND_ORG_UNITS:
    "/registration-setting-invitation/registration-setting",
  FETCH_NOTIFICATION_CANDIDATES:
    "/registration-setting-notification/registration-setting",
  SAVE_NOTIFICATION_CANDIDATE:
    "/registration-setting-notification/registration-setting",
  UPDATE_NOTIFICATION_CANDIDATE:
    "/registration-setting-notification/registration-setting",
  FETCH_NOTIFICATIONS:
    "/registration-setting-notification/registration-setting",
  DELETE_NOTIFICATION:
    "/registration-setting-notification/registration-setting",
  FETCH_ORG_UNITS_OPTIONS: "/registration-setting-setup",
  FETCH_REGISTRATIONS_SIMPLE_LIST: "/registration-setting",
  SAVE_EXISTING_ADD_ON_ITEMS: "/registration-add-on/registration-setting",
  FETCH_TRACK_DETAILS: "/registration-track/registration-setting",
  EXPORT_CSV: "/registration-track/registration-setting",
  SEARCH_PLAYERS_AND_TEAMS: "registration-track/search",
  FETCH_PAYMENT_ACCOUNTS: "/registration-setting/payment-accounts",
  CREATE_PAYMENT_ACCOUNT: "/registration-setting/payment-accounts",
  UPDATE_ACCEPT_PAYMENTS: "/registration-setting",
  CREATE_STRIPE_ACCOUNT: "/stripe/create-stripe-account",
  CREATE_STRIPE_ONBOARDING: "/stripe/stripe-onboarding",
  FETCH_MAIN_PAYMENT_ACCOUNT: "/registration-setting/payment-accounts",
  UPDATE_MAIN_PAYMENT_ACCOUNT: "/registration-setting/payment-accounts",
  CREATE_PAYPAL_ACCOUNT: "/paypal/create-paypal-account",
  FETCH_REGISTRATION_PLAYER_ANSWERS: "/registration-track/player-registration"
};
